export default "__VITE_ASSET__CHPppm8G__"